import React from "react";
import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import MostrarID from "./MostrarID";
import "./style.css"
import WhatsAppButton from "../../components/BtnWhatsapp/Whatsapp";


const Inmueble = () => {
    return (
        <>
            <Header />
            <div className="contianer-general">
                <MostrarID />
            </div>
            <Footer />
        </>
    );
};

export default Inmueble;
